import { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from "lucide-react";
import { useRecoilState } from 'recoil';
import { selectedCurrencyState } from '../store/selectedCurrencyAtom';
import { currencySigns } from '../utils/currencies';

export default function CurrencySelect() {
    const [currentCurrency, setCurrentCurrency] = useRecoilState(selectedCurrencyState);
    const [isActive, setActive] = useState(false);
    const ref = useRef();

    const setCurr = (curr) => {
        setCurrentCurrency(curr);
        setActive(false);
        localStorage.setItem('currency', curr); // Save the selected currency to localStorage
    }

    useEffect(() => {
        const savedCurrency = localStorage.getItem('currency') || 'EUR'; // Retrieve the saved currency from localStorage or default to 'EUR'
        setCurrentCurrency(savedCurrency);
    }, [setCurrentCurrency]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setActive(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref])

    return (
        <div ref={ref}>
            <div className={`flex justify-center align-center relative text-nunito text-[24px] -ml-2 -mt-[2px] font-semibold uppercase cursor-pointer hover:text-slate-400 transition`} onClick={() => setActive(!isActive)} id="curr-selected">
                {currencySigns[currentCurrency] || currentCurrency}
                {isActive
                    ? <ChevronUp className="mt-1" />
                    : <ChevronDown className="mt-1" />
                }
            </div>
            {isActive && (
                <div id="curr-dropdown" className={`relative w-full transition`}>
                    <div className={`rounded border z-[9999] w-[80px] border-slate-100 cursor-pointer absolute top-0 bg-white ${isActive}`}>
                        {Object.entries(currencySigns).map(([curr, sign]) => (
                            <div
                                className="text-lg bg-none border border-slate-100 p-1 text-center text-slate-400 uppercase transition hover:bg-slate-100 hover:text-slate-300"
                                key={curr}
                                value={sign}
                                onClick={() => setCurr(curr)}
                            >
                                {sign || ''}&nbsp;({curr})
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}